import { useEffect } from 'react'
import { trpcClient } from 'shared/api/core/trpc'
import { initStorage } from 'shared/lib/storage'
import { useAuthStore } from 'shared/store/auth'

export const AppInitializers = () => {
	useEffect(() => {
		async function init() {
			const user = await trpcClient.auth.Me.query()
			useAuthStore.setState({ user })
		}
		init()
		initStorage()
	}, [])

	return null
}
